import firstTrophy from "../../assets/tot-img/1st-prize-icon.png";
import secondTrophy from "../../assets/tot-img/2nd-prize-icon.png";
import thirdTrophy from "../../assets/tot-img/3rd-prize-icon.png";
import firstCash from "../../assets/tot-img/40K.png";
import secondCash from "../../assets/tot-img/20K.png";
import thirdCash from "../../assets/tot-img/10K.png";

export const prizeData = [
  {
    trophy: secondTrophy,
    cash: secondCash,
    position: 2,
  },
  {
    trophy: firstTrophy,
    cash: firstCash,
    position: 1,
  },
  {
    trophy: thirdTrophy,
    cash: thirdCash,
    position: 3,
  },
];
